/**************************************************
 * Nombre:       TituloHuella
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Typography} from "@mui/material";
import huella from '../../../../Recursos/huellas.svg'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const TituloHuella = ({titulo}) => {
    const {sCell,masSM} = useResponsive()

    return (
        <Typography sx={{fontSize: !masSM? 20 : 24, fontWeight: 700}}>
            {titulo}
            <span><img src={huella} width={50} height={'auto'}
                       style={{marginTop: -10, marginLeft: -20, marginBottom: 10}}/></span>
        </Typography>
    )

}
export default TituloHuella